// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UY0FK","toggle":"styles_toggle__3yGpz","preview":"styles_preview__2C9hE"};